import React from 'react'
import Show from './../components/show'

class Now_Playing extends React.Component {
	render() {
		return (
			<section className="container">
				<Show hero="true" />
			</section>
		)
	}
}

export default Now_Playing


// WEBPACK FOOTER //
// ./src/pages/now_playing.js